import React from 'react';
import ReactDOM from 'react-dom/client';
import './common/styles/css/index.css';
import './common/styles/css/custom-kiwox.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import reportWebVitals from './reportWebVitals';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <App />
);